//get the API result via jQuery.ajax
let countryCode = window.localStorage.getItem('PSCountry')
let countryCurrency = window.localStorage.getItem('PSCurrency')
let returnTo = document.querySelector("#geo_return_to");

returnTo.value = window.location.pathname;

if (countryCurrency) {
  selectedGeo(countryCurrency)
} else {
  fetch('/browsing_context_suggestions.json')
    .then(res => res.json())
    .then(data => {
      window.localStorage.setItem('PSCountry', data.detected_values.country.handle);
      setGeoClass(data.detected_values.country.handle);
    }).catch(error => {
      // Handle error
    });
}

function selectedGeo(countryCurrency) {
  const hideGeoPop = document.querySelector('.geolocation_custom');
  hideGeoPop.innerHTML = '';
  hideGeoPop.hide;
  document.body.classList.add('currency-selected');
}

function setGeoClass(location) {
  const showGeoPop = document.querySelector('.geolocation_custom');
  showGeoPop.style.display = 'flex';

  if (location == 'NZ') {
    // NZ and rest of world
    document.body.classList.add('nz-site');
  
    const currency = document.querySelectorAll('.currency_selector button');
    currency.forEach((btn) => {
      btn.addEventListener('click', () => {
        window.location.href = window.location.href;
        btn.classList.add('selected');
        window.localStorage.setItem('PSCurrency', btn.value);
      })
    });

    const closePopup = document.querySelector('.close_geo')
    closePopup.addEventListener('click', () => {
      window.location.href = window.location.href;
      window.localStorage.setItem('PSCurrency', 'NZ');
      document.body.classList.add('currency-selected');
    })

  } else if (location == 'GB' ) {
    document.body.classList.add('uk-site');
    
    const currency = document.querySelectorAll('.currency_selector button');
    currency.forEach((btn) => {
      btn.addEventListener('click', () => {
        window.location.href = window.location.href;
        btn.classList.add('selected');
        window.localStorage.setItem('PSCurrency', btn.value);
      })
    });

    const closePopup = document.querySelector('.close_geo')
    closePopup.addEventListener('click', () => {
      window.location.href = window.location.href;
      window.localStorage.setItem('PSCurrency', 'GB');
      document.body.classList.add('currency-selected');
    })
  } else {
    
    // USA only
    document.body.classList.add('us-site')
  
    const currency = document.querySelectorAll('.currency_selector button');
    currency.forEach((btn) => {
      btn.addEventListener('click', () => {
        window.location.href = window.location.href;
        btn.classList.add('selected');
        window.localStorage.setItem('PSCurrency', btn.value);
      })
    });

    const closePopup = document.querySelector('.close_geo')
    closePopup.addEventListener('click', () => {
      window.location.href = window.location.href;
      window.localStorage.setItem('PSCurrency', 'US');
      document.body.classList.add('currency-selected');
    })
  }
};
